import React, { useState } from 'react';
import axios from 'axios';
import './PhasesPage.css';
import { useAuth } from '../hooks/useAuth';

const API_URL = '/api';

function PhasesPage({ phases, onReload, onOpenPhase }) {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ nom: '', description: '' });
  const { user } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nom) {
      alert('Nom de la phase requis');
      return;
    }

    try {
      await axios.post(`${API_URL}/phases`, formData);
      setFormData({ nom: '', description: '' });
      setShowForm(false);
      onReload();
    } catch (err) {
      alert('Erreur: ' + err.message);
    }
  };

  return (
    <div className="phases-page">
      <div className="phases-header">
        <h2>🏗️ Gestion des Phases</h2>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? '✕ Fermer' : '➕ Nouvelle Phase'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="card phase-form">
          <div className="form-group">
            <label>Nom de la phase *</label>
            <input
              type="text"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              placeholder="Ex: Fondations"
              required
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Description de la phase..."
              rows="3"
            />
          </div>

          <button type="submit" className="btn btn-primary">💾 Créer la phase</button>
        </form>
      )}

      <div className="phases-grid">
        {phases.map(phase => (
          <div key={phase.id} className="phase-card card" onClick={() => onOpenPhase ? onOpenPhase(phase.id) : null} style={{cursor: onOpenPhase ? 'pointer' : 'default'}}>
            <h3>{phase.nom}</h3>
            <div className="phase-stats">
              <div className="stat">
                <div className="stat-number">{phase.task_count || 0}</div>
                <div className="stat-name">Tâches</div>
              </div>
              <div className="stat">
                <div className="stat-number">{phase.completed_tasks || 0}</div>
                <div className="stat-name">Terminées</div>
              </div>
              <div className="stat">
                <div className="stat-number">
                  {phase.task_count > 0 
                    ? Math.round((phase.completed_tasks / phase.task_count) * 100)
                    : 0}%
                </div>
                <div className="stat-name">Avancement</div>
              </div>
            </div>
            
            {phase.task_count > 0 && (
              <div className="phase-progress">
                <div className="progress-bar">
                  <div className="progress-fill" 
                    style={{
                      width: `${phase.task_count > 0 ? (phase.completed_tasks / phase.task_count) * 100 : 0}%`
                    }}
                  ></div>
                </div>
              </div>
            )}

            {/* Boutons d'action */}
            <div className="phase-actions">
              {user?.is_admin ? (
                <button
                  className="btn btn-danger"
                  onClick={async () => {
                    const proceed = phase.task_count > 0
                      ? window.confirm(`La phase contient ${phase.task_count} tâche(s). Voulez-vous supprimer la phase et toutes les tâches associées ? (OK = forcer)`)
                      : window.confirm('Supprimer cette phase ?');
                    if (!proceed) return;
                    try {
                      const force = phase.task_count > 0;
                      await axios.delete(`${API_URL}/phases/${phase.id}${force ? '?force=true' : ''}`);
                      onReload();
                    } catch (err) {
                      alert('Erreur suppression: ' + (err.response?.data?.error || err.message));
                    }
                  }}
                >
                  Supprimer
                </button>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PhasesPage;
